import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Transforming tags from location services api
 * @param {*} tagsRawData
 */
const transformCurrencyData = (currencyConfigurations) => {
  const currencies = [];
  currencyConfigurations.forEach((currency) => {
    currencies.push({ ...currency });
  });
  return currencies;
};

/**
 * Makes sure the centralSettings defaultCurrencyConfiguration response is complain with a basic schema
 * @param {*} currencyConfigurations
 */
const validateCurrencyResponse = (currencyConfigurations) => {
  const validation = { isValid: true, message: '' };
  if (!currencyConfigurations || typeof currencyConfigurations !== 'object') {
    validation.isValid = false;
    return {
      isValid: false,
      data: currencyConfigurations,
      message: 'INTEGRATION__LOCATION_SERVICE: airports must be an object'
    };
  }
  return validation;
};

/**
 * Retrieve currency from the central settings Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getCurrencies = (integrationSettings, meta, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__CENTRAL_SETTINGS_CURRENCY_CONFIGURATION: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    const { v1CentralSettings = {} } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v1CentralSettings;
    if (
      !v1CentralSettings ||
      !v1CentralSettings.method ||
      !v1CentralSettings.endpoint ||
      !v1CentralSettings.headers
    ) {
      const MESSAGE = `INTEGRATION__CENTRAL_SETTINGS_CURRENCY_CONFIGURATION: **integrationSettings.v1CentralSettings** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    axiosWrapper(
      {
        url: v1CentralSettings.endpoint,
        method: v1CentralSettings.method,
        headers: { ...v1CentralSettings.headers }
      },
      {
        resource: 'INTEGRATION__CENTRAL_SETTINGS_CURRENCY_CONFIGURATION',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then((response) => {
        const validation = validateCurrencyResponse(response.data.defaultCurrencyConfigurations);
        if (validation.isValid) {
          logger.info(
            'INTEGRATION__CENTRAL_SETTINGS_CURRENCY_CONFIGURATION: Successful request',
            response.data.defaultCurrencyConfigurations
          );
          const currencies = transformCurrencyData(response.data.defaultCurrencyConfigurations);
          resolve(currencies);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getCurrencies, transformCurrencyData };
